/**
 * Created by yougen on 3/26/15.
 */
    var $ = require("@alife/alpha-jquery/jquery.js"),
        Handlebars = require("@alife/alpha-handlebars/handlebars.js"),
        PrivacySample = require("./resource/privacy-sample"),
        Base = require("@alife/alpha-base/base.js"),
        Balloon = require("@alife/alpha-balloon/balloon.js"),
        tpl = require("./template/privacy-tip.tpl"),
        I18N = require('./privacy-i18n');


    Handlebars.registerHelper('I18N4CARD', function(key) {
        if (key) {
            return I18N.app[key] || '';
        }
        return '';
    });

    var PrivacyCard = Base.extend({
       attrs: {
          data: null,
          trigger: '',
          className: ''
       },
       renderCard: function(){
           var sourceData  = this.get("data") || {};
           var lang = sourceData.language || 'en-us';
           I18N = require('./privacy-i18n')._(lang) || I18N;
           var data = {
               email: sourceData.email || PrivacySample.email,
               fax: sourceData.fax || PrivacySample.fax,
               mobile: sourceData.mobile || PrivacySample.mobile,
               phone: sourceData.phone || PrivacySample.phone,
               senderName: sourceData.senderName || I18N.app['commons.card.example'],
               i18n: {
                    email: I18N.app['commons.card.email'],
                    fax: I18N.app['commons.card.fax'],
                    tel: I18N.app['commons.card.tel'],
                    phone: I18N.app['commons.card.phone']
               }
           };

           var content = Handlebars.compile(tpl)(data);
           new Balloon({
               content: content,
               trigger: this.get('trigger'),
               arrowPosition: 'bl',
               zIndex: 9999,
               className:this.get('className')
           });
       }
    });

    module.exports = PrivacyCard;
